import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {Card, CardContent, Typography} from '@mui/material';
import {palette} from '../../helpers/theme';
import {reviews} from './constants';

const styles = {
    wrapper: {
        mt: {xs: 4, md: 11.5},
    },
    titleWrapper: {
        px: {xs: '30px', md: 0},
    },
    title: {
        fontSize: {xs: 36, md: 54},
        textAlign: 'center',
        mx: 'auto',
    },
    titleHighlight: {
        fontSize: 'inherit',
        color: palette.primary[800],
    },
    subtitle: {
        fontSize: {xs: 18, md: 22},
        textAlign: 'center',
        fontStyle: 'italic',
        mt: 2,
        lineHeight: 1.4,
    },
    reviewsWrapper: {
        background: 'linear-gradient(180deg, #FFFFFF 0%, #EDFCF2 100%)',
        pt: {xs: 5, lg: '54px'},
        pb: {xs: 7, lg: '54px'},
        px: {xs: 3, md: 0},
    },
    reviewsList: {
        width: {md: '80%'},
        mx: 'auto',
    },
    reviewCard: {
        boxShadow: '0px 4px 12px 0px #00000026',
        p: 4,
        borderRadius: '16px',
        width: {lg: '33.3%'},
    },
    reviewContent: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        p: 0,

        '&:last-child': {
            pb: 0,
        },
    },
    review: {
        color: '#000000',
        mt: 2,
        fontSize: 18,
    },
    reviewAuthor: {
        textTransform: 'uppercase',
        color: palette.secondary[50],
        letterSpacing: '16%',
        pt: {xs: '20px', md: 7},
    },
};

const Reviews: React.FC = () => {
    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.titleWrapper}>
                <Typography component="h2" variant="h2" sx={styles.title}>
                    Just This Once,{' '}
                    <Typography component="span" variant="h2" sx={styles.titleHighlight}>
                        Follow the Crowd
                    </Typography>
                </Typography>
                <Typography component="p" variant="h4" sx={styles.subtitle}>
                    Thousands of people have chosen a permanent life insurance policy with Amplify.
                </Typography>
            </Box>
            <Box sx={styles.reviewsWrapper}>
                <Stack spacing={{xs: 2, lg: 4}} direction={{xs: 'column', lg: 'row'}} sx={styles.reviewsList}>
                    {reviews &&
                        reviews.map(({consumer, text, stars}, index) => (
                            <Card key={`${consumer?.displayName}_review_${index}`} sx={styles.reviewCard}>
                                <CardContent sx={styles.reviewContent}>
                                    <Box>
                                        <Box>
                                            <Stack direction="row">
                                                {[...Array(stars)]?.map((_, index) => (
                                                    <Box
                                                        key={`${consumer?.displayName}_${index}`}
                                                        component="img"
                                                        src="/images/star-v2.svg"
                                                        alt="Rating"
                                                        width="16px"
                                                        height="16px"
                                                    />
                                                ))}
                                            </Stack>
                                        </Box>
                                        <Typography variant="body1" sx={styles.review}>{`“${text}”`}</Typography>
                                    </Box>
                                    <Typography
                                        variant="subtitle2"
                                        sx={styles.reviewAuthor}
                                    >{`– ${consumer?.displayName}`}</Typography>
                                </CardContent>
                            </Card>
                        ))}
                </Stack>
            </Box>
        </Box>
    );
};

export default Reviews;
